import { Head, useForm, usePage } from "@inertiajs/react"
import { LoaderCircle } from "lucide-react"

import InputError from "../../components/input-error"
import { Button } from "../../components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card"
import { Input } from "../../components/ui/input"
import { Label } from "../../components/ui/label"

export default function Edit() {
  const { props } = usePage()
  const user = props.auth.user

  const { data, setData, patch, processing, errors, reset } = useForm({
    user: {
      current_password: "",
      password: "",
      password_confirmation: "",
    }
  })

  const submit = (e) => {
    e.preventDefault()

    patch(`/account/users/${user.id}`, {
      onSuccess: () => {
        reset()
      }
    })
  }

  return (
    <>
      <Head title="Account Settings" />
      
      <div className="container mx-auto py-8">
        <div className="max-w-md mx-auto space-y-6">
          <div>
            <h1 className="text-3xl font-bold">Account Settings</h1>
            <p className="text-muted-foreground">Change your password</p>
          </div>

          <Card>
            <CardHeader>
              <CardTitle>Change Password</CardTitle>
              <CardDescription>
                Update your account password
              </CardDescription>
            </CardHeader>
            <CardContent>
              <form onSubmit={submit} className="space-y-4">
                <div className="grid gap-2">
                  <Label htmlFor="current_password">Current Password</Label>
                  <Input
                    id="current_password"
                    type="password"
                    name="current_password"
                    value={data.user.current_password}
                    onChange={(e) => setData("user", { ...data.user, current_password: e.target.value })}
                    autoComplete="current-password"
                    required
                  />
                  <InputError message={errors["user.current_password"]} />
                </div>

                <div className="grid gap-2">
                  <Label htmlFor="password">New Password</Label>
                  <Input
                    id="password"
                    type="password"
                    name="password"
                    value={data.user.password}
                    onChange={(e) => setData("user", { ...data.user, password: e.target.value })}
                    autoComplete="new-password"
                    required
                  />
                  <InputError message={errors["user.password"]} />
                </div>

                <div className="grid gap-2">
                  <Label htmlFor="password_confirmation">Confirm New Password</Label>
                  <Input
                    id="password_confirmation"
                    type="password"
                    name="password_confirmation"
                    value={data.user.password_confirmation}
                    onChange={(e) => setData("user", { ...data.user, password_confirmation: e.target.value })}
                    autoComplete="new-password"
                    required
                  />
                  <InputError message={errors["user.password_confirmation"]} />
                </div>

                <Button type="submit" disabled={processing} className="w-full">
                  {processing && <LoaderCircle className="h-4 w-4 animate-spin" />}
                  {processing ? "Updating..." : "Update Password"}
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  )
}